import WinlinesView from "../../../vendor_core/core/src/views/WinlinesView";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { BitmapMoneyField } from "../../../vendor_core/core/src/views/BitmapMoneyField";

export default class BURWinBannerView extends WinlinesView {
    public setWinBannerValue(value: number, animate = false) {
        const layer = ViewManager.getLayer(DefaultLayers.PaylineCelebration);
        layer.clear();
        const scene = layer.setScene("totalWin", undefined, true);
        this.winValueBanner = scene.sceneMoneyFields.get(
            "value"
        ) as BitmapMoneyField;

        this.winValueBanner.value = value;
        this.playWinSound();
        this.emit(GameEvents.BANNER_ANIM_COMPLETE);
        this.winValueBanner.visible = true;
    }
}
